import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'

import {useGetTrackingEvents} from '../../hooks/useGetTrackingEvents.js'
import {useUtils} from '../../hooks/useUtils.js'
import {BASE_CLASS, PANEL_FINANCING_VERSION} from '../config.js'
import {PanelFinancingInfo} from '../detailFinancingInfo/PanelFinancingInfo.js'
import {PanelFinancingInstalment} from '../instalment/PanelFinancingInstalment.js'
import {PanelFinancingLenderInfo} from '../lenderInfo/PanelFinancingLenderInfo.js'

export const PanelFinancingSimplifiedContent = ({ad, isProfessional, financingData, onContactSellerCtaClick}) => {
  const {trackLegalContent} = useGetTrackingEvents()

  const {handleScrollToFinancingTerms} = useUtils()

  const handleOnClickCtaTerms = () => {
    trackLegalContent(ad)
    handleScrollToFinancingTerms()
  }

  return (
    <>
      <div className={`${BASE_CLASS}-content`}>
        <PanelFinancingInstalment
          isProfessional={isProfessional}
          loanCalculations={financingData}
          panelFinancingVersion={PANEL_FINANCING_VERSION.SIMPLIFIED}
        />
        <PanelFinancingInfo
          ad={ad}
          handleOnClickCtaTerms={handleOnClickCtaTerms}
          isPrivate={!isProfessional}
          loanCalculations={financingData}
          panelFinancingVersion={PANEL_FINANCING_VERSION.SIMPLIFIED}
        />
      </div>
      <PanelFinancingLenderInfo
        ad={ad}
        handleOnClickCtaTerms={handleOnClickCtaTerms}
        isPrivate={!isProfessional}
        loanCalculations={financingData}
        onContactSellerCtaClick={onContactSellerCtaClick}
        showContactSellerCta
        showLabel
      />
    </>
  )
}

PanelFinancingSimplifiedContent.propTypes = {
  ad: PropTypes.object,
  isProfessional: PropTypes.string,
  financingData: PropTypes.object,
  onContactSellerCtaClick: PropTypes.func
}
